module.exports = __webpack_public_path__ + "img/klarna.32f5c909.svg";